'use client';

import { registerFlexibleComponents } from '../ComponentRecognizer/registerFlexibleComponents';

/**
 * Client-side component that registers CMS components for use with ComponentRecognizer.
 * Registration is guarded internally to execute only once.
 *
 * @returns null - This component doesn't render anything
 */
export const ClientRegistration = () => {
  registerFlexibleComponents();
  return null;
};
